const DonationsData = [
  {
    "donation_id": 1,
    "hospital_name": "All India Institute of Medical Sciences (AIIMS)",
    "medicine": "Insulin",
    "quantity_needed": "50 vials",
    "reason": "Emergency shortage of insulin for diabetic patients in the ICU.",
    "location": "Ansari Nagar, New Delhi, India",
    "created_at": "2024-11-20T10:00:00Z",
    "contact_info": {
      "phone": "+91-11-26588500",
      "email": "info@aiims.edu.in"
    },
    "status": "open"
  },
  {
    "donation_id": 2,
    "hospital_name": "Fortis Escorts Heart Institute",
    "medicine": "Doxycycline",
    "quantity_needed": "200 tablets",
    "reason": "Increased cases of bacterial infections, urgent need for antibiotics.",
    "location": "Okhla Road, New Delhi, India",
    "created_at": "2024-11-21T14:00:00Z",
    "contact_info": {
      "phone": "+91-11-26825000",
      "email": "support@fortisescorts.in"
    },
    "status": "open"
  },
  {
    "donation_id": 3,
    "hospital_name": "Max Super Speciality Hospital",
    "medicine": "Oxygen Cylinders",
    "quantity_needed": "30 cylinders",
    "reason": "Critical shortage of oxygen for COVID-19 patients.",
    "location": "Saket, New Delhi, India",
    "created_at": "2024-11-19T09:30:00Z",
    "contact_info": {
      "phone": "+91-11-26515000",
      "email": "contact@maxhospital.com"
    },
    "status": "closed"
  },
  {
    "donation_id": 4,
    "hospital_name": "Medanta – The Medicity",
    "medicine": "Vitamin D3",
    "quantity_needed": "100 bottles",
    "reason": "Needed for patients with severe deficiencies, especially elderly.",
    "location": "Gurgaon Road, New Delhi, India",
    "created_at": "2024-11-22T08:00:00Z",
    "contact_info": {
      "phone": "+91-11-41730800",
      "email": "donations@medanta.org"
    },
    "status": "open"
  },
  {
    "donation_id": 5,
    "hospital_name": "Rajiv Gandhi Cancer Institute & Research Centre",
    "medicine": "Chemotherapy Drugs",
    "quantity_needed": "100 doses",
    "reason": "Urgent requirement for chemotherapy treatment.",
    "location": "Rohini, New Delhi, India",
    "created_at": "2024-11-23T16:00:00Z",
    "contact_info": {
      "phone": "+91-11-47025500",
      "email": "info@rgci.org.in"
    },
    "status": "open"
  }
];

export default DonationsData;
